import { render, staticRenderFns } from "./TextAreaInput.vue?vue&type=template&id=48038bd2&scoped=true&"
import script from "./TextAreaInput.vue?vue&type=script&lang=js&"
export * from "./TextAreaInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48038bd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48038bd2')) {
      api.createRecord('48038bd2', component.options)
    } else {
      api.reload('48038bd2', component.options)
    }
    module.hot.accept("./TextAreaInput.vue?vue&type=template&id=48038bd2&scoped=true&", function () {
      api.rerender('48038bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/forms/TextAreaInput.vue"
export default component.exports